import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonProps } from '@aqarmap/aqarmap-ui';

type Props = Pick<ButtonProps, 'isLoading' | 'disabled'> & {
  onSubmitBtnClick?: () => void;
};

const FormActions: React.FC<Props> = ({
  isLoading,
  disabled,
  onSubmitBtnClick,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('app');
  return (
    <div className="flex items-center gap-2x border-t border-gray pt-3x px-2x md:px-3x">
      <Button
        size="medium"
        ariaLabel="submit-btn"
        type="submit"
        variant="primary"
        isLoading={isLoading}
        disabled={disabled}
        onClick={onSubmitBtnClick}
        className="w-auto"
      >
        {t('save')}
      </Button>

      <Button
        size="medium"
        ariaLabel="cancel-btn"
        type="button"
        variant="secondary"
        className="w-auto"
        onClick={() => navigate(-1)}
      >
        {t('cancel')}
      </Button>
    </div>
  );
};

export default FormActions;
